import React, { useMemo, useState } from "react";
import { dialog } from "../../components/ui/Dialog";
import { procCur, procDiff, procFmt } from "./procHelpers";
import { procName } from "./procPeople";
import { Icon, PrIco, ProcAv } from "./ProcUi";

// Historique des versions d'une page — repris du prototype
// (procedures-lib.jsx), avec la confirmation de restauration via la boîte de
// dialogue de l'application.
const ProcHistory = ({ page, onClose, onRestore }) => {
  const vs = [...page.versions].reverse();
  const cur = procCur(page);
  const [sel, setSel] = useState(vs[0].v);
  const [mode, setMode] = useState(vs.length > 1 ? "prev" : "view");
  const v = page.versions.find((x) => x.v === sel);
  const prev = page.versions.find((x) => x.v === sel - 1);
  const base = mode === "cur" ? cur : prev;
  const diff = useMemo(
    () => (base && mode !== "view"
      ? (mode === "cur" ? procDiff(v.html, cur.html, v.title, cur.title) : procDiff(base.html, v.html, base.title, v.title))
      : null),
    // `base`, `v` et `cur` se déduisent de sel/mode et de la page, déjà couverts
    // ci-dessous : les ajouter relancerait le calcul du diff à chaque rendu.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sel, mode]
  );

  const restaurer = async () => {
    const ok = await dialog.confirm(
      `Restaurer la version ${sel} ? Une nouvelle version v${cur.v + 1} sera créée, rien n'est perdu.`,
      { variant: "default", title: "Restaurer cette version", confirmLabel: "Restaurer" }
    );
    if (ok) {
      onRestore(sel);
      onClose();
    }
  };

  return (
    <div className="scrim" onClick={onClose}>
      <div className="pr-hist" onClick={(e) => e.stopPropagation()}>
        <div className="pr-hist-head">
          <span className="pr-hist-ico"><PrIco n="history" s={18} /></span>
          <div>
            <h2>Historique des versions</h2>
            <div className="pr-hist-sub">{cur.title} · {page.versions.length} version{page.versions.length > 1 ? "s" : ""}</div>
          </div>
          <button className="x-btn" onClick={onClose}><Icon name="x" size={16} /></button>
        </div>
        <div className="pr-hist-body">
          <div className="pr-hist-list">
            {vs.map((x) => (
              <button
                key={x.v}
                className={`pr-hv ${x.v === sel ? "on" : ""}`}
                onClick={() => {
                  setSel(x.v);
                  if (x.v === 1 && mode === "prev") setMode("view");
                  if (x.v === cur.v && mode === "cur") setMode(x.v > 1 ? "prev" : "view");
                }}
              >
                <span className="pr-hv-v">v{x.v}</span>
                <span className="pr-hv-main">
                  <span className="pr-hv-sum">{x.summary}</span>
                  <span className="pr-hv-meta"><ProcAv id={x.author} size={18} /> {procName(x.author)} · {procFmt(x.date)}</span>
                </span>
                {x.v === cur.v && <span className="pr-hv-cur">Actuelle</span>}
              </button>
            ))}
          </div>
          <div className="pr-hist-view">
            <div className="pr-hist-bar">
              <div className="pr-seg">
                <button className={mode === "view" ? "on" : ""} onClick={() => setMode("view")}>Aperçu</button>
                <button className={mode === "prev" ? "on" : ""} disabled={!prev} onClick={() => setMode("prev")}>Changements de v{sel}</button>
                <button className={mode === "cur" ? "on" : ""} disabled={sel === cur.v} onClick={() => setMode("cur")}>Comparer à l'actuelle</button>
              </div>
              {diff && <span className="pr-diff-stat"><span className="add">+{diff.add}</span><span className="del">−{diff.del}</span></span>}
              {sel !== cur.v && (
                <button className="btn primary pr-hist-restore" onClick={restaurer}>
                  <PrIco n="restore" s={14} /> Restaurer v{sel}
                </button>
              )}
            </div>
            <div className="pr-hist-scroll">
              {mode === "view" && (
                <div className="pr-content">
                  <h1 className="pr-hist-t">{v.title}</h1>
                  <div dangerouslySetInnerHTML={{ __html: v.html }}></div>
                </div>
              )}
              {diff && (
                <div className="pr-diff">
                  <div className="pr-diff-legend">
                    {mode === "cur"
                      ? <>De <b>v{sel}</b> vers <b>v{cur.v}</b> (actuelle)</>
                      : <>De <b>v{sel - 1}</b> vers <b>v{sel}</b> — {procName(v.author)}, {procFmt(v.date)}</>}
                  </div>
                  {diff.rows.map((r, i) => (
                    <div key={i} className={`pr-dl ${r.op === "+" ? "add" : r.op === "-" ? "del" : r.op === "~" ? "chg" : ""}`}>
                      <span className="pr-dl-m">{r.op === "=" ? "" : r.op === "~" ? "±" : r.op === "-" ? "−" : "+"}</span>
                      <span className="pr-dl-t">
                        {r.op === "~"
                          ? r.words.map((w, j) => (w.op === "=" ? <span key={j}>{w.t}</span> : <span key={j} className={w.op === "+" ? "w-add" : "w-del"}>{w.t}</span>))
                          : r.t}
                      </span>
                    </div>
                  ))}
                  {diff.add === 0 && diff.del === 0 && <div className="pr-empty">Aucune différence de contenu.</div>}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcHistory;
